import { isLogger } from './settings'

interface LoggingCollection {
  log: {
    (data: string): void,
  },
  error: {
    (data: string): void,
  },
  json: {
    (data: any): void,
  }
}

export const emptyLogger: LoggingCollection = {
  log: (data) => {},
  error: (data) => {},
  json: (data) => {},
}

export const activeLogger: LoggingCollection = {
  log: (data) => console.log(data),
  error: (data) => console.error(data),
  json: (data) => console.log(JSON.stringify(data, null, 4)),
}

export const getLogger: {
  (test: boolean): LoggingCollection,
} = (test) => test ? activeLogger : emptyLogger

const baseLogger = getLogger(isLogger())

export const logger = (st: string, isError = false) => {
  if(isError) {
    baseLogger.error(st)
  }
  else {
    baseLogger.log(st)
  }
}

export const jsonLogger = (data: any) => {
  baseLogger.json(data)
}